import React from "react";
import PropTypes from "prop-types";
import DonutChart from "react-donut-chart";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { countDuplicate, requiredCols } from "../../utils/helpers";

class PoActivities extends React.Component {
  state = {
    cols: "",
    allCsvData: "",
    csvData: "",
    activityType: "",
    paginatedTable: {
      totalPage: "",
      currentPage: 1,
      currentData: ""
    },
    pieData: ""
  };

  componentDidMount() {
    this.getAllData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allCsvData !== this.props.allCsvData) {
      this.getAllData();
    }
  }

  getAllData = () => {
    let { allCsvData, districtName } = this.props;
    let { data, columns } = allCsvData;
    let cols = columns && columns.filter(d => requiredCols.includes(d));
    data =
      data &&
      data.filter(
        d =>
          d &&
          districtName &&
          d.District.toUpperCase() === districtName.toUpperCase()
      );
    let pieData = this.getPieData(data);

    let currentData = data && data.slice(0, 100);
    let totalPage = Math.ceil((data && data.length - 1) / 100);

    this.setState({
      allCsvData: data,
      csvData: data,
      pieData,
      cols,
      paginatedTable: { totalPage, currentPage: 1, currentData }
    });
  };

  getPieData = data => {
    let pieData = data && data.map(d => d["Partner Organization"]);
    return countDuplicate(pieData);
  };

  render() {
    let {
        cols,
        pieData,
        csvData
    } = this.state;
      cols = cols && cols.filter( d => d != 'District');
      let columns = cols && cols.reduce( (acc,item) => acc.concat({Header: item,accessor:item}), []) || [];
    pieData = pieData && pieData.sort( (a,b) => b.value - a.value);
    return (
      <div className="po-activities">
        <div className="row">
          <div className="col-xs-12 col-sm-3 col-md-2">
            <div className="panel panel-primary fixed-height-panel">
              <div className="panel-heading">
                <h1 className="panel-title">Number of activities</h1>
              </div>
              <div className="panel-body" id="pieChart">
                <DonutChart
                  data={pieData ? pieData : []}
                  height={195}
                  width={150}
                  innerRadius={0.4}
                  outerRadius={0.95}
                  legend={false}
                  clickToggle={false}
                />
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-9 col-md-10" id="fullscreen-table">
            <div style={{maxWidth:"100% !important","overflow-x":"scroll"}}>
              <ReactTable
                  data={csvData || []}
                  columns={columns}
                  defaultPageSize={100}
                  style={{
                      height:"315px",
                      minWidth:"1200px"
                  }}
                  className="-striped -highlight"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PoActivities.propTypes = {
  districtName: PropTypes.string.isRequired
};

export default PoActivities;
